export const locale = {
    lang: 'zh2',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO':	'设定',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO':	'上载员工数据库',
            'BOTON':	'设定',
          },
          'BOT2':{
            'TITULO':	'上传公司徽标',
            'BOTON':	'设定',
          },
          'BOT3':{
            'TITULO':	'技术要求资料',
            'BOTON':	'查看更多',
          }
        },
        'BD':{
          'TITUHEAD':	'上载员工数据库',
          'INFO':	'将您公司的员工数据库上传到系统中',
          'BOTONES':{
            'DescTemp':	'下载范本',
          },
          'MENSAJES':{
            'CARGABD':	'上载BD',
            'STATUS':	'状态',
            'CORRECTO':	'数据库上传成功',
            'ERROR':	'上传发生错误',
          }
        },
        'LOGO':{
          'TITUHEAD':	'上传公司徽标',
          'INFO':	'上载公司徽标图像',
          'MENSAJES':{
            'CARGA':	'上传徽标图片',
            'STATUS':	'状态',
            'CORRECTO':	'徽标已成功上传',
            'ERROR':	'上传发生错误',
          }
        },
        'REQTEC':{
          'TITUHEAD':	'技术要求资料',
          'INFO':	'平台以最佳功能运行的技术要求',
          'MENSAJES':{
            'CARGA': '',
            'STATUS':	'状态',
            'CORRECTO':	'已成功加载',
            'ERROR':	'加载错误',
          }
        }
      }
    }
};
